<script setup lang="ts">
  import { useGoogleAnalytics } from '@/shared/composables'
  const gaService = useGoogleAnalytics()

  interface Props {
    policyNumber: string
  }
  const props = defineProps<Props>()

  const openApp = () => {
    gaService.sendAppDownloadPromo(props.policyNumber)

    const appLink = 'http://qic.online/l/ticket'
    window.open(appLink)
  }
</script>

<template>
  <div class="banner-promo">
    <img src="@/shared/assets/images/success-gift.png" alt="gift" class="banner-promo__image" />
    <p class="banner-promo__title">{{ $t('ramadan.success_page.title') }}</p>
    <p class="banner-promo__subtitle">{{ $t('ramadan.success_page.subtitle') }}</p>
    <img src="@/shared/assets/images/app-qr.svg" alt="qr code" class="banner-promo__qr-code" />
    <span class="banner-promo__scan">{{ $t('ramadan.success_page.scan') }}</span>
    <button class="banner-promo__button" @click="openApp">
      {{ $t('ramadan.success_page.button.go_to_store') }}
    </button>
  </div>
</template>

<style scoped lang="scss">
  @import './SuccessBanner';
</style>
